const obscureEmail = (email) => {
    const [name, domain] = email.split('@');
    return `${name[0]}${name[1]}${new Array(name.length-2).join('*')}${name[name.length-1]}@${domain}`;
};
export default obscureEmail;